import request from '@/utils/request'
import api from '.'
const userApi = {
  queryMenu: '/authorize/menu/queryTreeLists',//首页菜单查询

  Login: '/authorize/authorization/studentLogin',
  loginOut: '/authorize/authorization/login/out',
  generateVerificationCode: '/authorize/verification/code/generateVerificationCode', // 生成验证码
  studentQueryInfo: '/authorize/studentInfo/findBycode',//查询学生信息
  studentUpdateInfo:'/authorize/studentInfo/update',//修改学生信息
  queryExamTicketInfo:'/authorize/studentInfo/queryExamTicketInfo',//查询准考证信息
  querySportsWithPage:'/authorize/setSportsProject/queryWithPage',//查询设置体育考试项目
  queryRegistrationPointWithPage:'/authorize/registrationPoint/queryWithPage',//查询报名点信息
  queryExamTimeWithPage:'/authorize/examTime/queryWithPage',//查询考试时间
  modifyPassword: '/authorize/student/modifyPassword',

  queryWithPage: '/news/news/queryWithPage',//获取新闻列表
  newsFindById: '/news/news/findById', // 通过id获取新闻信息
  advertisementPage: '/news/advertisement/queryWithPage', //获取广告

  interpretToken: '/authorize/token/interpretToken', // 用户Token解析
  categoryQueryTreeLists: '/news/category/queryTreeLists', // 新闻类型列表

  examQueryUserInfo: '/exam/achievement/queryUserInfo', // 分页查询学生成绩信息
  newsNext: '/news/news/getNewsNext',//获取下一条新闻
  newsPre: '/news/news/getNewsPre' ,//获取上一条新闻
  newsContent: '/news/news/getNews' ,//获取新闻信息
  studentFindById: '/authorize/studentInfo/findById', // 通过ID查询学生信息
  studentFindByCode: '/authorize/studentInfo/findBycode', // 通过code查询学生信息
  findSportExamTypeByYear:'/authorize/setSportsProject/findSportExamTypeByYear',//根据年份查询体育考试类型

  getBatchTree:'/recruit/students/batch/volunteer/queryTreeLists', //获取志愿批次树形图
  getMajorByBatchCode: '/recruit/students/optional/items/queryMajorLists',//通过批次代码获取专业
  getSchoolByBatchCode: '/recruit/students/optional/items/querySchoolLists',//通过批次代码获取学校
  volunteerAdd:"/recruit/students/volunteer/add",
  deleteVolunteer:"/recruit/students/volunteer/delete",//清空志愿
  volunteerAddVolunteer:"/recruit/students/volunteer/addVolunteer",
  getNumByYear:'/recruit/students/volunteerCount/findByYear',//根据年份查询志愿填报次数
  getSETime: '/authorize/start/end/time/queryList', //查询起止时间
  getFindVolunteerStatusSETime: '/authorize/start/end/time/findVolunteerStatus', //查询志愿开关


  enrollmentPlanQueryWithPage:'/recruit/students/enrollment/plan/queryWithPage',//查询招生计划
  getCounty:'/authorize/county/queryCounty',//获取县市
  getSchool:'/authorize/schoolInfo/querySchoolInfo',//获取学校
  queryEnrollmentPlanSchool:'/recruit/students/enrollment/plan/querySchool',//招生计划获取学校
  queryByTypes: '/authorize/dictionary/queryByTypes', // 根据多个字典集类型标识查询字典集
  queryRegion:'/authorize/region/findByParentId',//根据ID查询户籍地
  queryMailingAddress:'/authorize/region/findByPid',//通讯地址


  //中央民族大学
  centralAdd:'/recruit/students/central/Family/add',//提交填报志愿
  getCenterSchool:'/recruit/students/central/Family/findByUserInfo',//获取填报志愿信息


  //查询录取信息
  getAdmission:"/recruit/students/admission/queryAdmissionInfo",

  // 通过Id查询新闻类别信息
  categoryFindById:'/news/category/findById',

  // 根据年份查询当年有多少批次
  queryBatchByYear: '/recruit/students/batch/volunteer/queryBatchByYear',

//  录取结果确认
  confirmAdmissionResults: '/recruit/students/admission/confirmAdmissionResults',

//  获取当前时间
  getPresentDate: '/authorize/start/end/time/getPresentDate',

//  特长生报名
  querySportsArtSpeciality: '/authorize/sports/art/speciality/queryWithPage', //分页查询体艺特长生报名信息
  sportsArtSpecialityAdd: '/authorize/sports/art/speciality/add', //新增体艺特长生报名信息
  sportsArtSpecialityUpdate: '/authorize/sports/art/speciality/update', //修改体艺特长生报名信息
  deleteSportsArtSpecialityUpdateById: '/authorize/sports/art/speciality/deleteById', //根据Id删除体艺特长生报名信息
  schoolQueryWithPage: '/authorize/schoolInfo/queryWithPage', // 分页查询学校
  schoolMajorQueryWithPage: '/recruit/students/enrollment/plan/queryMajor', // 查询学校专业
  queryCountyByEnrollmentPlan: '/recruit/students/enrollment/plan/queryCountyByEnrollmentPlan', //特长生报名县市查询
  queryMajorByEnrollmentPlan: '/recruit/students/enrollment/plan/queryMajorByEnrollmentPlan', //特长生报名专业
  querySchoolByEnrollmentPlan: '/recruit/students/enrollment/plan/querySchoolByEnrollmentPlan', //特长生报名学校

}
export function categoryFindById (param) {
  return request({
    url: userApi. categoryFindById,
    method: 'post',
    params: param
  })
}
export function getAdmission () {
  return request({
    url: userApi. getAdmission,
    method: 'post',
  })
}
export function getCenterSchool () {
  return request({
    url: userApi. getCenterSchool,
    method: 'post',
  })
}
export function centralAdd (data) {
  return request({
    url: userApi. centralAdd,
    method: 'post',
    data: data
  })
}
export function getSchool (data) {
  return request({
    url: userApi.getSchool,
    method: 'post',
    data:data
  })
}
export function queryEnrollmentPlanSchool (data) {
  return request({
    url: userApi.queryEnrollmentPlanSchool,
    method: 'post',
    data:data
  })
}
export function getCounty (data) {
  return request({
    url: userApi.getCounty,
    method: 'post',
    data:data
  })
}
export function queryByTypes (parameter) {
  return request({
    url: userApi.queryByTypes,
    method: 'post',
    data: parameter
  })
}
export function queryRegion (parameter) {
  return request({
    url: userApi.queryRegion,
    method: 'post',
    params: parameter
  })
}
export function queryMailingAddress (parameter) {
  return request({
    url: userApi.queryMailingAddress,
    method: 'post',
    params: parameter
  })
}

export function enrollmentPlanQueryWithPage (parameter,data) {
  return request({
    url: userApi. enrollmentPlanQueryWithPage,
    method: 'post',
    params: parameter,
    data: data
  })
}
export function getSETime (parameter) {
  return request({
    url: userApi.getSETime,
    method: 'post',
    data: parameter
  })
}
export function getFindVolunteerStatusSETime (parameter) {
  return request({
    url: userApi.getFindVolunteerStatusSETime,
    method: 'post',
    data: parameter
  })
}
export function examQueryUserInfo() {
  return request({
    url: userApi.examQueryUserInfo,
    method: 'post',
  })
}
export function volunteerAdd(body) {
  return request({
    url: userApi.volunteerAdd,
    method: 'post',
    data: body
  })
}
export function volunteerAddVolunteer(body) {
  return request({
    url: userApi.volunteerAddVolunteer,
    method: 'post',
    data: body
  })
}
export function deleteVolunteer(parameter) {
  return request({
    url: userApi.deleteVolunteer,
    method: 'post',
    params: parameter
  })
}
export function getNumByYear(body) {
  return request({
    url: userApi.getNumByYear,
    method: 'post',
    data: body
  })
}
export function categoryQueryTreeLists(body) {
  return request({
    url: userApi.categoryQueryTreeLists,
    method: 'post',
    data: body
  })
}

export function newsFindById(parameter) {
  return request({
    url: userApi.newsFindById,
    method: 'post',
    params: parameter
  })
}

export function interpretToken() {
  return request({
    url: userApi.interpretToken,
    method: 'post',
  })
}

export function menuList(body) {
  return request({
    url: userApi.queryMenu,
    method: 'post',
    data: body
  })
}

export function Login(parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    params: parameter
  })
}
export function loginOut() {
  return request({
    url: userApi.loginOut,
    method: 'post',
  })
}

export function generateVerificationCode(parameter) {
  return request({
    url: userApi.generateVerificationCode,
    method: 'post',
    params: parameter
  })
}

export function studentQueryInfo() {
  return request({
    url: userApi.studentQueryInfo,
    method: 'post',
  })
}
export function studentUpdateInfo(body) {
  return request({
    url: userApi.studentUpdateInfo,
    method: 'post',
    data:body
  })
}
export function queryExamTicketInfo() {
  return request({
    url: userApi.queryExamTicketInfo,
    method: 'post',
  })
}
export function querySportsWithPage(parameter,body) {
  return request({
    url: userApi.querySportsWithPage,
    method: 'post',
    params: parameter,
    data: body
  })
}
export function queryRegistrationPointWithPage(parameter,body) {
  return request({
    url: userApi.queryRegistrationPointWithPage,
    method: 'post',
    params: parameter,
    data: body
  })
}
export function queryExamTimeWithPage(parameter,body) {
  return request({
    url: userApi.queryExamTimeWithPage,
    method: 'post',
    params: parameter,
    data: body
  })
}

export function studentModifyPassword(body) {
  return request({
    url: userApi.modifyPassword,
    method: 'post',
    data: body
  })
}

export function queryWithPage(parameter, body) {
  return request({
    url: userApi.queryWithPage,
    method: 'post',
    params: parameter,
    data: body
  })
}

export function advertisementPages(parameter, body = {}) {
  return request({
    url: userApi.advertisementPage,
    method: 'post',
    params: parameter,
    data: body
  })
}

export function studentFindById(parameter) {
  return request({
    url: userApi.studentFindById,
    method: 'post',
    params: parameter
  })
}
export function studentFindByCode() {
  return request({
    url: userApi.studentFindByCode,
    method: 'post',
  })
}
export function findSportExamTypeByYear(param) {
  return request({
    url: userApi.findSportExamTypeByYear,
    method: 'post',
    params: param
  })
}



export function getBatchTree(parameter) {
  return request({
    url: userApi.getBatchTree,
    method: 'post',
    data: parameter
  })
}
// 上一篇数据
export function getNewsPre(parameter) {
  return request({
    url: userApi.newsPre,
    method: 'post',
    data: parameter
  })
}

//下一篇数据
export function getNewsNext(parameter) {
  return request({
    url: userApi.newsNext,
    method: 'post',
    data: parameter
  })
}
export function newsContent(parameter) {
  return request({
    url: userApi.newsContent,
    method: 'post',
    data: parameter
  })
}

export function getMajorByBatchCode(parameter) {
  return request({
    url: userApi.getMajorByBatchCode,
    method: 'post',
    data: parameter
  })
}
export function getSchoolByBatchCode(parameter) {
  return request({
    url: userApi.getSchoolByBatchCode,
    method: 'post',
    data: parameter
  })
}
export function queryBatchByYear(parameter) {
  return request({
    url: userApi.queryBatchByYear,
    method: 'post',
    data: parameter
  })
}
export function confirmAdmissionResults(parameter) {
  return request({
    url: userApi.confirmAdmissionResults,
    method: 'post',
    data: parameter
  })
}

export function getPresentDate () {
  return request({
    url: userApi.getPresentDate,
    method: 'post',
  })
}

export function querySportsArtSpeciality (parameter, body) {
  return request({
    url: userApi.querySportsArtSpeciality,
    method: 'post',
    params: parameter,
    data: body
  })
}
export function sportsArtSpecialityAdd (body) {
  return request({
    url: userApi.sportsArtSpecialityAdd,
    method: 'post',
    data: body
  })
}
export function sportsArtSpecialityUpdate (body) {
  return request({
    url: userApi.sportsArtSpecialityUpdate,
    method: 'post',
    data: body
  })
}
export function deleteSportsArtSpecialityUpdateById (parameter) {
  return request({
    url: userApi.deleteSportsArtSpecialityUpdateById,
    method: 'post',
    params: parameter,
  })
}
export function schoolQueryWithPage (parameter, body) {
  return request({
    url: userApi.schoolQueryWithPage,
    method: 'post',
    params: parameter,
    data: body
  })
}
export function schoolMajorQueryWithPage (body) {
  return request({
    url: userApi.schoolMajorQueryWithPage,
    method: 'post',
    data: body
  })
}
export function queryCountyByEnrollmentPlan (body) {
  return request({
    url: userApi.queryCountyByEnrollmentPlan,
    method: 'post',
    data: body
  })
}
export function queryMajorByEnrollmentPlan (body) {
  return request({
    url: userApi.queryMajorByEnrollmentPlan,
    method: 'post',
    data: body
  })
}
export function querySchoolByEnrollmentPlan (body) {
  return request({
    url: userApi.querySchoolByEnrollmentPlan,
    method: 'post',
    data: body
  })
}
